import { Injectable, inject } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import {PDisciplineScolarDifficulty} from '../../model/param/p-discipline-scolar-difficulty';
import {PDisorderDys} from '../..//model/param/p-disorder-dys.model';
import {PSchoolHelp} from '../..//model/param/p-school-help.model';
import {PSchoolLevel} from '../../model/param/p-school-level.model';
import {PScolarDifficulty} from '../../model/param/p-scolar-difficulty';
import {Webservice} from './webservice';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ParamWebservice extends Webservice {
  protected readonly httpBackend = inject(HttpBackend);
  private readonly httpBypass = new HttpClient(this.httpBackend);

  constructor() {
    super();
    this.entity = 'param';
  }

  getAllSchoolLevels(): Observable<PSchoolLevel[]> {
    return this.httpBypass.get<PSchoolLevel[]>(`${this.root}/schoolLevels`);
  }

  getAllScolarDifficulty(onlyActive: boolean = true): Observable<PScolarDifficulty[]> {
    return this.httpBypass.get<PScolarDifficulty[]>(
      `${this.root}/scolarDifficulty?onlyActive=${onlyActive}`
    );
  }

  getAllDisciplineScolarDifficulty(onlyActive: boolean = true) {
    return this.httpBypass.get<PDisciplineScolarDifficulty[]>(
      `${this.root}/disciplineScolarDifficulty?onlyActive=${onlyActive}`
    );
  }

  getAllSchoolHelp(onlyActive: boolean = true) {
    return this.http.get<PSchoolHelp[]>(`${this.root}/school-help?onlyActive=${onlyActive}`);
  }

  getAllDisorderDys(onlyActive: boolean = true) {
    return this.http.get<PDisorderDys[]>(`${this.root}/disorder-dys?onlyActive=${onlyActive}`);
  }
}
